// extracted by mini-css-extract-plugin
export default {"googleBtn":"GoogleAuth_googleBtn__063s0","googleIcon":"GoogleAuth_googleIcon__Xzoce","googleLabel":"GoogleAuth_googleLabel__jJIxJ"};